import { render } from "./OkrPeriodModeSwitch.vue?vue&type=template&id=25120d94&scoped=true"
import script from "./OkrPeriodModeSwitch.vue?vue&type=script&lang=js"
export * from "./OkrPeriodModeSwitch.vue?vue&type=script&lang=js"

import "./OkrPeriodModeSwitch.vue?vue&type=style&index=0&id=25120d94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25120d94"]])

export default __exports__